
// constants as defined in RevoXef’s App\Models\Menu\MenuItem
const NORMAL = 0
const MENU = 1
const LINKED = 2
// const TICKET = 3
const SELLING_FORMAT = 4
// const GIFT_CARD = 5
// const MANAGEMENT_ONLY = 6
const KIT = 7
// const SEPARATOR = 8
// const INTOUCH_RELOAD = 9

const ENABLED_TYPES = [
  NORMAL,
  MENU,
  LINKED,
  SELLING_FORMAT,
  KIT,
]

export default {
  NORMAL,
  MENU,
  LINKED,
  SELLING_FORMAT,
  KIT,
  enabled: v => ENABLED_TYPES.indexOf(v) !== -1,
}
